module.exports = {
  width: { value: '{fontSizes.xxl.value}' },
  height: { value: '{fontSizes.xxl.value}' },
  strokeEmpty: { value: '{colors.neutral.20.value}' },
  strokeFilled: { value: '{colors.brand.primary.80.value}' },
  strokeLinecap: { value: 'round' },
  animationDuration: { value: '1s' },
  small: {
    width: { value: '{fontSizes.medium.value}' },
    height: { value: '{fontSizes.medium.value}' },
  },
  large: {
    width: { value: '{fontSizes.xxxl.value}' },
    height: { value: '{fontSizes.xxxl.value}' },
  },
  linear: {
    width: { value: '100%' },
    minWidth: { value: '5rem' },
    height: { value: '{fontSizes.xxs.value}' },
    strokeWidth: { value: '{fontSizes.xxs.value}' },
    strokeFilled: { value: '{colors.brand.primary.80.value}' },
    strokeEmpty: { value: '{colors.neutral.20.value}' },
    strokeLinecap: { value: 'round' },
    animationDuration: { value: '1s' },
    small: {
      height: { value: '{fontSizes.xxxs.value}' },
      strokeWidth: { value: '{fontSizes.xxxs.value}' },
    },
    large: {
      height: { value: '{fontSizes.xs.value}' },
      strokeWidth: { value: '{fontSizes.xs.value}' },
    },
  },
};
